export default "__VITE_PUBLIC_ASSET__2c4e9d01__"